'use client'

import { Currency } from '@/types/Page'
import React, { ReactElement, useContext } from 'react'
import { useWizardSelector } from '@/components/ui/wizard/WizardState'
import { SearchPageContext } from '@/components/pages/search-page/SearchPageContext'
import { Provider } from 'react-redux'
import { Store } from '@reduxjs/toolkit'
import FilterModal from '@/components/ui/wizard/filter/FilterModal'
import { OrderModal } from '@/components/ui/wizard/filter/Order'
import { useOnMobileOrTablet } from '@/lib/hooks'

export default function SearchPageModals(props: { currency: Currency }): ReactElement {
  const { storeInitialized } = useContext(SearchPageContext)

  return storeInitialized ? (
    <Provider store={window.store as Store}>
      {' '}
      <Modals {...props} />{' '}
    </Provider>
  ) : (
    <></>
  )
}

function Modals(props: { currency: Currency }): ReactElement {
  const { setSearchOptionsType, searchOptionsType } = useContext(SearchPageContext)
  const locationFilter = useWizardSelector((s) => s.locationFilter)
  const numberOfGuests = useWizardSelector((s) => s.numberOfGuests)
  const rating = useWizardSelector((s) => s.rating)
  const maximumPrice = useWizardSelector((s) => s.maximumPrice)
  const onMobile = useOnMobileOrTablet()

  function close(): void {
    setSearchOptionsType(undefined)
  }

  if (!onMobile) {
    return <></>
  }

  return (
    <Provider store={window.store as Store}>
      <FilterModal
        close={close}
        type={searchOptionsType}
        currency={props.currency}
        key={`${locationFilter.length}${numberOfGuests}${rating || ''}${maximumPrice || ''}`}
      />
      <OrderModal close={close} type={searchOptionsType} />
    </Provider>
  )
}
